import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/** Filter options for the pre-TAGS_ENHANCED `tags` column, which filters by tag name rather than id. */
export function useTagNameFilterOptions(tagNames: string[] | undefined) {
  const { t } = useTranslation(["tags"]);
  return useMemo(
    () => [
      { value: "all", label: t(($) => $.tags["All Tags"]) },
      ...(tagNames ?? []).map((name) => ({ value: name, label: name })),
    ],
    [tagNames, t],
  );
}
